import Avatar from '@basic/Avatar';
import LogoIcon from '@icons/LogoIcon';
import MentorIcon from '@icons/MentorIcon';
import MasterAvatar from '@master/MasterAvatar';
import { setupForDark } from '@theme';
import classNames from 'classnames';

function UserAvatar({
  pictureUrl,
  size = 32,
  isProducer = false,
  isMaster = false,
  isChatbot = false,
  animateLoading = false
}: {
  pictureUrl: string;
  size?: number;
  isProducer?: boolean;
  isMaster?: boolean;
  isChatbot?: boolean;
  animateLoading?: boolean;
}) {
  if (isMaster) {
    return (
      <div className='relative'>
        <MasterAvatar size={size} />
      </div>
    );
  }

  if (isChatbot) {
    return (
      <div className='relative'>
        <div
          className='rounded-full bg-black flex items-center justify-center overflow-hidden'
          style={{ width: size, height: size }}
        >
          <LogoIcon
            size={size}
            backgroundColor='transparent'
            strokeColor='white'
            animateLoading={animateLoading}
          />
        </div>
      </div>
    );
  }

  return (
    <div className='relative'>
      <Avatar src={pictureUrl} size={size} />
      {isProducer && (
        <MentorIcon
          size={(size * 10.67) / 32}
          className={classNames('absolute bottom-0 right-[-1px]', setupForDark('text-icon-yellow'))}
        />
      )}
    </div>
  );
}

export default UserAvatar;
